module.exports = __webpack_public_path__ + "static/media/ic_document_mobile.ceee6be6.svg";